<template>
  <v-dialog v-model="localShowValue" persistent scrollable>
    <v-card>
      <v-card-title>
        <h3 class="withBackground"><div class="pl-1">Add New Rating Set</div></h3>
      </v-card-title>
      <v-card-text>
        <v-form ref="ratingsSetPopupForm" v-model="validRatingsSetPopup">
          <v-row>
            <v-col xl="6" lg="7" md="8" sm="9" class="px-0 pb-2">
              <LabelDatefield
                labelXl="3"
                labelLg="4"
                labelMd="5"
                labelSm="6"
                textXl="3"
                textLg="4"
                textMd="6"
                textSm="6"
                :isEditable="!addingOrEditingLoadRatingDetails"
                label="LR.04 Calculation Date"
                id="calculationDate"
                v-model="calculationDate"
                isRequired
                @update:model-value="updateRatingDate()"
                :invalidDates="calculationDates"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="px-0">
              <v-btn
                :disabled="addingOrEditingLoadRatingDetails"
                id="btn_add_Posting"
                variant="outlined"
                class="mr-1"
                @click="addRating"
                >Add Load Type</v-btn
              >
            </v-col>
          </v-row>
          <v-row class="mb-2">
            <v-col cols="12">
              <v-data-table
                v-model:expanded="expandedRows"
                :headers="detailsHeadersEditable"
                :items="localLoadRatingDetails"
                class="lessPaddingTableColumns"
                :items-per-page="-1"
                v-model:sort-by="sortBy"
                hide-default-footer
                must-sort
                show-expand
                return-object
              >
                <template v-slot:[`header.data-table-expand`]="{ column }">
                  {{ column.title }}
                </template>
                <template v-slot:[`header.LOAD_TYPE`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.NBI_RATING_IND`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.RATING_ANALYSIS_METHOD`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.IRLOAD`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.ORLOAD`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.SLC_RATING`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.IR_LOAD_FACTOR`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.OR_LOAD_FACTOR`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.SUPPORT_DATASET`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>
                <template v-slot:[`header.action`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortBy" />
                </template>

                <template v-slot:item="{ item }">
                  <tr :class="rowClassDetails(item)">
                    <td class="text-center">
                      <button v-if="!expandedRows.includes(item)" @click="toggleRowDetails(item)">
                        <v-icon :id="`icon_Chevron_Right_${item.UNIQUE_KEY}`" icon="fa-solid fa-chevron-right"></v-icon>
                      </button>

                      <button v-else-if="expandedRows.includes(item)" @click="toggleRowDetails(item)">
                        <v-icon :id="`icon_Chevron_Down_${item.UNIQUE_KEY}`" icon="fa-solid fa-chevron-down"></v-icon>
                      </button>
                    </td>
                    <td class="text-center">
                      {{
                        item?.LOAD_TYPE ? configStore.getReferenceValue(REFERENCE_TABLE.LOAD_TYPE, item?.LOAD_TYPE) : ""
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        item?.NBI_RATING_IND
                          ? configStore.getReferenceValue(REFERENCE_TABLE.NBI_RATING, item?.NBI_RATING_IND)
                          : ""
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        item?.RATING_ANALYSIS_METHOD
                          ? configStore.getReferenceValue(
                              REFERENCE_TABLE.LOAD_RATING_METHOD,
                              item?.RATING_ANALYSIS_METHOD,
                            )
                          : ""
                      }}
                    </td>

                    <td class="text-center">
                      {{
                        item.IRLOAD
                      }}
                    </td>

                    <td class="text-center">
                      {{
                        item.ORLOAD
                      }}
                    </td>

                    <td class="text-center">
                      {{
                        item.SLC_RATING
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        Number.parseFloat(item.IR_LOAD_FACTOR)
                          ? Number.parseFloat(item.IR_LOAD_FACTOR).toFixed(2)
                          : item.IR_LOAD_FACTOR
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        Number.parseFloat(item.OR_LOAD_FACTOR)
                          ? Number.parseFloat(item.OR_LOAD_FACTOR).toFixed(2)
                          : item.OR_LOAD_FACTOR
                      }}
                    </td>
                    <td class="text-center">
                      {{ item.SUPPORT_DATASET }}
                    </td>
                    <td class="alignCenter">
                      <div style="white-space: nowrap" v-if="!item.readOnly && addingOrEditingLoadRatingDetails">
                        <IconTooltip
                          :id="`icon_add_${item.POSTING_KEY}`"
                          icon="fa-solid fa-check"
                          :tooltip="item?.isAdd ? 'Add' : 'Update'"
                          @click="saveRating(item)"
                        />
                        <IconTooltip
                          :id="`icon_close_${item.POSTING_KEY}`"
                          icon="fa-solid fa-xmark"
                          tooltip="Close"
                          @click="closeRating"
                        />
                      </div>
                      <div
                        style="white-space: nowrap"
                        v-else-if="expandedRows?.length == 0 && !addingOrEditingLoadRatingDetails"
                      >
                        <IconTooltip
                          :id="`icon_edit_${item.UNIQUE_KEY}`"
                          icon="fa-solid fa-pencil"
                          tooltip="Edit"
                          @click="editRating(item)"
                        />
                        <IconTooltip
                          :id="`icon_edit_${item.UNIQUE_KEY}`"
                          icon="fa-solid fa-trash"
                          tooltip="Delete"
                          @click="deleteRating(item)"
                        />
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:expanded-row="{ item }">
                  <td :colspan="detailsHeadersEditable.length">
                    <v-form ref="loadRatingsDetailsForm" v-model="validLoadRatingsDetails" class="mt-2">
                      <v-row class="mt-1">
                        <v-col
                          xl="6"
                          lg="6"
                          md="12"
                          sm="12"
                          cols="12"
                          :class="$vuetify?.display?.mdAndDown ? '' : 'pb-0'"
                        >
                          <LabelDatefield
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="calcDate"
                            label="LR.04 Calculation Date"
                            v-model="item.RATING_DATE"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          xl="6"
                          lg="6"
                          md="12"
                          sm="12"
                          cols="12"
                          :class="$vuetify?.display?.mdAndDown ? '' : 'pt-0 pb-0'"
                        >
                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="loadType"
                            label="B.EP.01 Load Type"
                            v-model="item.LOAD_TYPE"
                            :refTable="REFERENCE_TABLE.LOAD_TYPE"
                            :isEditable="!item.readOnly"
                            :isRequired="!item.readOnly"
                            @update:model-value="updateOnLoadTypeOrRatingMethodChange(item)"
                          />
                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="nbiRating"
                            label="LR.07 NBI"
                            v-model="item.NBI_RATING_IND"
                            :refTable="REFERENCE_TABLE.NBI_RATING"
                            :isEditable="!item.readOnly"
                            :isRequired="!item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="ratingMethod"
                            label="LR.08 Load Rating Method"
                            v-model="item.RATING_ANALYSIS_METHOD"
                            :refTable="REFERENCE_TABLE.LOAD_RATING_METHOD"
                            :isEditable="!item.readOnly"
                            :isRequired="!item.readOnly"
                            @update:model-value="updateOnLoadTypeOrRatingMethodChange(item)"
                          />
                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="memberType"
                            label="LR.09 Ctrl Member Type"
                            v-model="item.CONTROL_MEM_TYPE"
                            :refTable="REFERENCE_TABLE.CONTROLLING_MEMBER_TYPE"
                            :isEditable="!item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="stressCategoryType"
                            label="LR.10 Fatigue Stress Category"
                            v-model="item.FATIG_STRESS_CAT"
                            :refTable="REFERENCE_TABLE.CONTROLLING_MEMBER_FATIGUE_STRESS_CATEGORY"
                            :isEditable="!item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="fatigueLoadType"
                            label="LR.11 Fatigue Load Type"
                            v-model="item.FATIG_LOAD_TYPE"
                            :refTable="REFERENCE_TABLE.FATIGUE_LOAD_TYPE"
                            :isEditable="!item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            id="manYr"
                            :counter="false"
                            :maxlength="4"
                            label="LR.12 AASHTO Man Yr"
                            v-model="item.AASHTO_MANUAL_YEAR"
                            :isEditable="!item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            :counter="false"
                            :maxlength="4"
                            id="specYr"
                            label="LR.13 AASHTO Spec Yr"
                            v-model="item.AASHTO_SPEC_YEAR"
                            :isEditable="!item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            type="text"
                            label="LR.14 Engineer"
                            id="engineer"
                            v-model="item.ANALYSIS_ENGINEER"
                            counter="30"
                            maxlength="30"
                            :isEditable="!item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                        </v-col>
                        <v-col
                          xl="6"
                          lg="6"
                          md="12"
                          sm="12"
                          cols="12"
                          :class="$vuetify?.display?.mdAndDown ? '' : 'pt-0'"
                        >
                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="invRating"
                            label="LR.15 Inventory Rating"
                            v-model="item.IRLOAD"
                            appendWith=" Tons"
                            :roundingFactor="
                              loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                                ? ROUNDING_FACTOR.ROUND_DOWN
                                : ROUNDING_FACTOR.ROUND
                            "
                            type="number"
                            :isEditable="
                              !item.readOnly && !loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            :isRequired="
                              !item.readOnly && !loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            @update:model-value="loadRatingStore.updateLegalLoadRatingFactor(item)"
                            :maxlength="3"
                            :rules="
                              !item.readOnly
                                ? [
                                    (value) => {
                                      return valueInRangeRule(value, 0, 999);
                                    },
                                  ]
                                : []
                            "
                          />
                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="operatorRating"
                            label="LR.16 Operating Rating"
                            v-model="item.ORLOAD"
                            appendWith=" Tons"
                            :roundingFactor="
                              loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                                ? ROUNDING_FACTOR.ROUND_DOWN
                                : ROUNDING_FACTOR.ROUND
                            "
                            type="number"
                            :isEditable="
                              !item.readOnly && !loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            :isRequired="
                              !item.readOnly && !loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            @update:model-value="loadRatingStore.updateLegalLoadRatingFactor(item)"
                            :maxlength="3"
                            :rules="
                              !item.readOnly
                                ? [
                                    (value) => {
                                      return valueInRangeRule(value, 0, 999);
                                    },
                                  ]
                                : []
                            "
                          />

                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="slcRating"
                            label="LR.17 SLC Rating"
                            v-model="item.SLC_RATING"
                            appendWith=" Tons"
                            :roundingFactor="ROUNDING_FACTOR.ROUND"
                            type="number"
                            :isEditable="
                              !item.readOnly && !loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            @update:model-value="changesDetectedRating = true"
                            :maxlength="3"
                            :rules="
                              !item.readOnly
                                ? [
                                    (value) => {
                                      return valueInRangeRule(
                                        value,
                                        0,
                                        item.ORLOAD,
                                      );
                                    },
                                  ]
                                : []
                            "
                          />

                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="irRatingFactor"
                            label="LR.18 IR Rating Factor"
                            v-model="item.IR_LOAD_FACTOR"
                            :maxlength="4"
                            :decimalPlaces="2"
                            type="number"
                            :isEditable="
                              !item.readOnly && loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            :isRequired="
                              !item.readOnly && loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            @update:model-value="loadRatingStore.updateLegalLoadRatingFactor(item)"
                            :rules="
                              !item.readOnly
                                ? [
                                    (value) => {
                                      return valueInRangeRule(value, 0, 3);
                                    },
                                  ]
                                : []
                            "
                          />

                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="orRatingFactor"
                            label="LR.19 OR Rating Factor"
                            v-model="item.OR_LOAD_FACTOR"
                            :maxlength="4"
                            :decimalPlaces="2"
                            type="number"
                            :isEditable="
                              !item.readOnly && loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            :isRequired="
                              !item.readOnly && loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)
                            "
                            @update:model-value="loadRatingStore.updateLegalLoadRatingFactor(item)"
                            :rules="
                              !item.readOnly
                                ? [
                                    (value) => {
                                      return valueInRangeRule(value, 0, 3);
                                    },
                                  ]
                                : []
                            "
                          />
                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="critInventory"
                            label="LR.20 Govern Crit Inventory"
                            v-model="item.INV_RATING_STRESS_METHOD"
                            :refTable="REFERENCE_TABLE.GOVERNING_CRITERIA"
                            :isEditable="!item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />

                          <LabelSelect
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            selectXl="7"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="critOperating"
                            label="LR.21 Govern Crit Operating"
                            :refTable="REFERENCE_TABLE.GOVERNING_CRITERIA"
                            v-model="item.OPR_RATING_STRESS_METHOD"
                            :isEditable="!item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          ></LabelSelect>

                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="stressRange"
                            label="LR.22 Stress Range"
                            :roundingFactor="ROUNDING_FACTOR.TENTH"
                            :decimalPlaces="1"
                            v-model="item.STRESS_RANGE"
                            appendWith=" ksi"
                            type="number"
                            :isEditable="!item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                            :maxlength="5"
                            :rules="
                              !item.readOnly
                                ? [
                                    (value) => {
                                      return valueInRangeRule(value, 0, 999.9);
                                    },
                                  ]
                                : []
                            "
                          />
                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="legalLoadRatingFactor"
                            label="B.EP.02 Legal Load Rating Factor"
                            :roundingFactor="ROUNDING_FACTOR.HUNDRETH"
                            :decimalPlaces="2"
                            v-model="item.LEGAL_LOAD_RF"
                            type="number"
                          />
                          <div>
                            <v-row>
                              <v-col xl="5" sm="6">
                                <v-label class="bold">B.EP.03 Vehicle Posting Type: </v-label></v-col
                              >
                              <v-col class="pl-4">{{
                                loadRatingStore.vehiclePostTypesDisplayValue(item.lrVehiclePostTypes)
                              }}</v-col>
                            </v-row>
                          </div>
                          <LabelText
                            labelXl="5"
                            labelLg="6"
                            labelMd="6"
                            labelSm="6"
                            textXl="7"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="vehiclePostingValue"
                            label="B.EP.04 Vehicle Posting Value"
                            appendWith=" Tons"
                            :roundingFactor="ROUNDING_FACTOR.ROUND"
                            type="number"
                            v-model="item.VEH_POST_WEIGHT"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col sm="12" class="pb-0">
                          <LabelText
                            style="padding-left: 4px !important; padding-bottom: 0px !important"
                            labelXl="12"
                            labelLg="12"
                            labelMd="12"
                            labelSm="12"
                            textXl="12"
                            textLg="12"
                            textMd="12"
                            textSm="12"
                            type="textarea"
                            label="LR.23 Rating Dataset"
                            id="ratingDataset"
                            v-model="item.SUPPORT_DATASET"
                            counter="100"
                            maxlength="100"
                            persistentCounter
                            :isEditable="!item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col sm="12" class="pt-0 pb-0">
                          <LabelText
                            style="
                              padding-left: 4px !important;
                              padding-top: 0px !important;
                              padding-bottom: 4px !important;
                            "
                            labelXl="12"
                            labelLg="12"
                            labelMd="12"
                            labelSm="12"
                            textXl="12"
                            textLg="12"
                            textMd="12"
                            textSm="12"
                            type="textarea"
                            label="LR.24 Notes"
                            id="notes"
                            v-model="item.NOTES"
                            :counter="notesMaxLength"
                            :maxlength="notesMaxLength"
                            persistentCounter
                            :isEditable="!item.readOnly"
                            @update:model-value="changesDetectedRating = true"
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </td> </template
                ><template v-slot:bottom> </template></v-data-table></v-col
          ></v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col class="align-right">
            <v-btn class="mr-1" :disabled="addingOrEditingLoadRatingDetails" variant="outlined" @click="handleSubmit()"
              >Add</v-btn
            >
            <v-btn :disabled="addingOrEditingLoadRatingDetails" variant="outlined" @click="closePopup">Close</v-btn>
          </v-col>
        </v-row>
      </v-card-actions></v-card
    >
  </v-dialog>
  <ConfirmDialog ref="closeConfirm" :cancelButtonText="BUTTONS.NO" />
</template>
<script setup>
import { ref, toRefs, watch, computed, nextTick } from "vue";
import { useLoadRatingStore } from "@/components/inspection/store/loadRating";
import { useConfigStore } from "@/stores/config";
import { clone } from "@/util/clone";
import { RATING_LOAD } from "@/constants/LoadRatingAndPosting.js";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { ROUNDING_FACTOR } from "@/constants/RoundingFactors";
import { useSnackbarStore } from "@/stores/snackbar";
import { useInspectionLinksStore } from "@/stores/inspectionLinks";
import { INSPECTION_MESSAGES } from "@/constants/InspectionConstants";
import { SNACKBAR_MESSAGE_TYPES } from "@/constants/GlobalSnackbar.js";
import { BUTTONS, COMMON_MESSAGE_CONSTANTS } from "@/constants/CommonWebConstants";
import { LOGGER } from "@/util/logger";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelText from "@/components/common/LabelText.vue";
import LabelDatefield from "@/components/common/LabelDatefield.vue";
import IconTooltip from "@/components/common/IconTooltip.vue";
import DataTableHeader from "@/components/common/DataTableHeader.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { valueInRangeRule } from "@/composables/validationRules";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import { getISOFormattedDateNoTime, getISOFormattedDateWithTime } from "@/composables/dateField.js";

const props = defineProps({
  show: { default: false },
  brkey: { default: null },
  ratingSet: { default: [] },
  activePostingRecord: { default: null },
  postingHistory: { default: [] },
});

const emit = defineEmits(["close", "reloadNotesComments", "addRatingSet"]);
const snackbarStore = useSnackbarStore();
const inspectionLinksStore = useInspectionLinksStore();

let { show, ratingSet, brkey, activePostingRecord, postingHistory } = toRefs(props);
let localShowValue = ref(show.value);
let loadRatingDetails = ref(clone(ratingSet.value));
let localLoadRatingDetails = ref(clone(ratingSet.value));
let calculationDate = ref(null);
let changesDetected = ref(false);
let ratingsSetPopupForm = ref(null);
let validRatingsSetPopup = ref(false);

const loadRatingStore = useLoadRatingStore();

const handleSubmit = async () => {
  if (validRatingsSetPopup.value) {
    prepareRatingsSetObjectForSubmit();
    const addRatingSetObject = {
      ratingSet: localLoadRatingDetails.value,
      calculationDate: getISOFormattedDateNoTime(calculationDate.value),
    };
    emit("addRatingSet", addRatingSetObject);
    localShowValue.value = false;
    snackBarId.value = snackbarStore.showMessage({
      displayText: "Rating set added successfully. You must save to keep the changes.",
      timeout: 10000,
      callback: snackbarStore.removeMessage(snackBarId.value),
    });
  } else {
    validationSnackbar.value = true;
  }
};

const closePopup = () => {
  if (changesDetected.value) {
    closeConfirm.value
      .open(INSPECTION_MESSAGES.POPUP_DETECT_CHANGE_CONFIRMATION_MESSAGE, BUTTONS.YES)
      .then((response) => {
        if (!response) {
          changesDetected.value = false;
          localShowValue.value = false;
          emit("close");
        }
      });
  } else {
    localShowValue.value = false;
    emit("close");
  }
};

let expandedRows = ref([]);
const configStore = useConfigStore();
let duplicateLoadTypeValidationSnackbar = ref(false);
let duplicateLoadTypeTextId = ref("");
const closeConfirm = ref(null);

let sortBy = ref([{ key: "LOAD_TYPE", order: "asc" }]);
let previousSortBy = ref([{ key: "LOAD_TYPE", order: "asc" }]);
const detailsHeadersEditable = ref([
  {
    key: "data-table-expand",
    width: "3%",
  },
  {
    line1: "B.EP.01",
    line2: "Load",
    line3: "Type",
    key: "LOAD_TYPE",
    sortable: true,
  },
  {
    line1: "LR.07",
    line2: "NBI",
    line3: "",
    key: "NBI_RATING_IND",
    sortable: true,
  },
  {
    line1: "LR.08",
    line2: "Load Rating",
    line3: "Method",
    key: "RATING_ANALYSIS_METHOD",
    sortable: true,
  },
  {
    line1: "LR.15",
    line2: "IR",
    line3: "Tons",
    key: "IRLOAD",
    sortable: true,
    width: "8%",
  },
  {
    line1: "LR.16",
    line2: "OR",
    line3: "Tons",
    key: "ORLOAD",
    sortable: true,
    width: "8%",
  },
  {
    line1: "LR.17",
    line2: "SLC",
    line3: "Tons",
    key: "SLC_RATING",
    sortable: true,
    width: "8%",
  },
  {
    line1: "LR.18",
    line2: "IR",
    line3: "RF",
    key: "IR_LOAD_FACTOR",
    sortable: true,
    width: "8%",
  },
  {
    line1: "LR.19",
    line2: "OR",
    line3: "RF",
    key: "OR_LOAD_FACTOR",
    sortable: true,
    width: "8%",
  },
  {
    line1: "LR.23",
    line2: "Rating",
    line3: "Dataset",
    key: "SUPPORT_DATASET",
    width: "12%",
    sortable: true,
  },
  {
    line1: null,
    line2: "Action",
    line3: null,
    key: "action",
    sortable: false,
  },
]);

let loadRatingsDetailsForm = ref();
let changesDetectedRating = ref(false);
let snackBarId = ref(null);
let validLoadRatingsDetails = ref(true);

let addingOrEditingLoadRatingDetails = computed({
  get() {
    return inspectionLinksStore.isAddingOrEditingLoadRatingDetails;
  },
  set(value) {
    inspectionLinksStore.isAddingOrEditingLoadRatingDetails = value;
  },
});

let validationSnackbar = computed({
  get() {
    return inspectionLinksStore.showValidationSnackbar;
  },
  set(value) {
    inspectionLinksStore.showValidationSnackbar = value;
  },
});

const notesMaxLength = computed(() => {
  return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.NOTES_MAX_LENGTH);
});

const rowClassDetails = (data) => {
  return expandedRows.value?.find((a) => a.UNIQUE_KEY === data.UNIQUE_KEY) ? "rowSelect" : "rowUnselect";
};

const getLoadRatingDetails = () => {
  expandedRows.value = [];

  localLoadRatingDetails.value = clone(loadRatingDetails.value);
  if (!localLoadRatingDetails.value?.[0]) {
    //remove null values from array(if any)
    localLoadRatingDetails.value = localLoadRatingDetails.value?.filter((a) => !!a);
  }
  //set unique key for toggle expansion
  for (const element of localLoadRatingDetails.value ?? []) {
    element.UNIQUE_KEY = element.LOAD_TYPE + "-" + element.NBI_RATING_IND;
    element.RATING_LOAD_ID = null;
    element.MODTIME = null;
    element.USERKEY = null;
    element.readOnly = true;
  }
  localLoadRatingDetails.value = loadRatingStore.sortDetails(localLoadRatingDetails.value);
};
const prepareRatingsSetObjectForSubmit = () => {
  for (const element of localLoadRatingDetails.value ?? []) {
    element.RATING_LOAD_ID = null;
    element.MODTIME = null;
    element.USERKEY = null;
    element.RATING_DATE = getISOFormattedDateNoTime(calculationDate.value);
  }
};

const updateVehiclePostTypeAndWeight = (item) => {
  if (["0", "1", "2", "8", "A", "B", "C"].includes(item.LOAD_TYPE)) {
    item.lrVehiclePostTypes = loadRatingStore.getVehiclePostTypes(activePostingRecord.value?.VEH_POST_TYPES);
    item.VEH_POST_TYPES = loadRatingStore.convertToVehPostTypeObjects(item, item.lrVehiclePostTypes, true);
  }
  updateVehiclePostingValue(item);
};

const updateVehiclePostingValue = (item) => {
  const postedPosting = postingHistory.value.find((posting) => posting.POST_STATUS == "P");
  if (postedPosting) {
    switch (item.LOAD_TYPE) {
      case "0":
      case "1":
      case "8":
      case "A":
      case "C":
        item.VEH_POST_WEIGHT = postedPosting.POST_LIMIT_WEIGHT;
        break;
      case "2":
      case "B":
        if (postedPosting.POST_LIMIT_COMB > 0) {
          item.VEH_POST_WEIGHT = postedPosting.POST_LIMIT_COMB;
        } else {
          item.VEH_POST_WEIGHT = null;
        }
        break;
      default:
        item.VEH_POST_WEIGHT = null;
        break;
    }
  }
};

const updateOnLoadTypeOrRatingMethodChange = (item) => {
  changesDetectedRating.value = true;
  updateInventoryAndOperatingRating(item);
  updateVehiclePostTypeAndWeight(item);
  loadRatingStore.updateLegalLoadRatingFactor(item);
  nextTick(() => {
    loadRatingsDetailsForm.value?.validate();
  });
};

const updateInventoryAndOperatingRating = (item) => {
  if (loadRatingStore.inventoryAndOperatingRatingConditionalCheck(item)) {
    item.IRLOAD = loadRatingStore.getRating(item, "IR");
    item.ORLOAD = loadRatingStore.getRating(item, "OR");
    item.SLC_RATING = null;
  } else {
    item.IR_LOAD_FACTOR = null;
    item.OR_LOAD_FACTOR = null;
  }
};

const convertToRatingLoadObject = (details) => {
  let ratingLoadObject = clone(RATING_LOAD);
  ratingLoadObject.BRKEY = details.BRKEY;
  ratingLoadObject.RATING_DATE = details.RATING_DATE;
  ratingLoadObject.RATING_KEY = details.RATING_KEY;
  ratingLoadObject.AASHTO_MANUAL_YEAR = details.AASHTO_MANUAL_YEAR;
  ratingLoadObject.AASHTO_SPEC_YEAR = details.AASHTO_SPEC_YEAR;
  ratingLoadObject.ANALYSIS_ENGINEER = details.ANALYSIS_ENGINEER;
  ratingLoadObject.CONTROL_MEM_TYPE = details.CONTROL_MEM_TYPE;
  ratingLoadObject.CREATEDATETIME = details.CREATEDATETIME;
  ratingLoadObject.CREATEUSERKEY = details.CREATEUSERKEY;
  ratingLoadObject.FATIG_LOAD_TYPE = details.FATIG_LOAD_TYPE;
  ratingLoadObject.FATIG_STRESS_CAT = details.FATIG_STRESS_CAT;
  ratingLoadObject.INV_RATING_STRESS_METHOD = details.INV_RATING_STRESS_METHOD;
  ratingLoadObject.IRLOAD = details.IRLOAD;
  ratingLoadObject.IR_LOAD_FACTOR = details.IR_LOAD_FACTOR;
  ratingLoadObject.LEGAL_LOAD_RF = details.LEGAL_LOAD_RF;
  ratingLoadObject.LOAD_TYPE = details.LOAD_TYPE;
  ratingLoadObject.NBI_RATING_IND = details.NBI_RATING_IND;
  ratingLoadObject.NOTES = details.NOTES;
  ratingLoadObject.OPR_RATING_STRESS_METHOD = details.OPR_RATING_STRESS_METHOD;
  ratingLoadObject.ORLOAD = details.ORLOAD;
  ratingLoadObject.OR_LOAD_FACTOR = details.OR_LOAD_FACTOR;
  ratingLoadObject.RATING_ANALYSIS_METHOD = details.RATING_ANALYSIS_METHOD;
  ratingLoadObject.SLC_RATING = details.SLC_RATING;
  ratingLoadObject.STRESS_RANGE = details.STRESS_RANGE;
  ratingLoadObject.SUPPORT_DATASET = details.SUPPORT_DATASET;
  ratingLoadObject.MODTIME = details.MODTIME;
  ratingLoadObject.USERKEY = details.USERKEY;
  ratingLoadObject.VEH_POST_WEIGHT = details.VEH_POST_WEIGHT;
  ratingLoadObject.VEH_POST_TYPES = loadRatingStore.convertToVehPostTypeObjects(
    ratingLoadObject,
    details.lrVehiclePostTypes,
    true,
  );

  return ratingLoadObject;
};

const toggleRowDetails = (detail) => {
  detail.lrVehiclePostTypes = loadRatingStore.getVehiclePostTypes(detail.VEH_POST_TYPES);
  if (expandedRows.value.includes(detail)) {
    const index = expandedRows.value.findIndex((d) => d.UNIQUE_KEY == detail.UNIQUE_KEY);
    expandedRows.value.splice(index, 1);
  } else {
    expandedRows.value.push(detail);
  }
};

const updateNBI = (item) => {
  if (item.NBI_RATING_IND == "1") {
    for (const ratingLoad of loadRatingDetails.value ?? []) {
      if (ratingLoad.NBI_RATING_IND == "1" && ratingLoad.RATING_KEY != item.RATING_KEY) {
        ratingLoad.NBI_RATING_IND = "0";
      }
    }
  }
};

const updateRatingDate = () => {
  changesDetected.value = true;
  for (let ratingLoad of loadRatingDetails.value) {
    ratingLoad.RATING_DATE = getISOFormattedDateNoTime(calculationDate.value);
  }
  getLoadRatingDetails();
};

const saveRating = (detail) => {
  duplicateLoadTypeValidationSnackbar.value = false;
  validationSnackbar.value = false;
  loadRatingsDetailsForm.value
    .validate()
    .then(() => {
      const isValidLoadType = loadRatingStore.validateLoadType(detail, localLoadRatingDetails.value);
      if (validLoadRatingsDetails.value && isValidLoadType) {
        if (!loadRatingDetails.value?.[0]) {
          //remove null values from array(if any)
          loadRatingDetails.value = loadRatingDetails.value?.filter((a) => !!a);
        }
        updateOnLoadTypeOrRatingMethodChange(detail);
        changesDetectedRating.value = false;
        if (detail.isAdd) {
          loadRatingDetails.value.push(convertToRatingLoadObject(detail));
        } else {
          //update existing detail
          const updateIndex = loadRatingDetails.value.findIndex((a) => a.RATING_KEY === detail.RATING_KEY);
          loadRatingDetails.value.splice(updateIndex, 1, convertToRatingLoadObject(detail));
        }
        updateNBI(detail);

        //if all required fields entered - close the expanded row
        changesDetected.value = true;
        expandedRows.value = [];
        addingOrEditingLoadRatingDetails.value = false;
        snackbarStore.removeMessage(snackBarId.value);
        getLoadRatingDetails();
        sortBy.value = previousSortBy.value?.map((x) => x);
      } else {
        if (!validLoadRatingsDetails.value) {
          validationSnackbar.value = true;
        }
        if (!isValidLoadType) {
          duplicateLoadTypeValidationSnackbar.value = true;
        }
      }
    })
    .catch((err) => {
      LOGGER.logException(err);
      changesDetectedRating.value = false;
    });
};

const editRating = (rating) => {
  previousSortBy.value = sortBy.value.map((x) => x);
  snackBarId.value = snackbarStore.showMessage({
    displayText: INSPECTION_MESSAGES.RATINGS_DATATABLE,
  });
  rating.lrVehiclePostTypes = loadRatingStore.getVehiclePostTypes(rating.VEH_POST_TYPES);
  rating.readOnly = false;
  addingOrEditingLoadRatingDetails.value = true;
  expandedRows.value.push(rating);
  nextTick(() => loadRatingsDetailsForm.value?.validate());
};

const deleteRating = (item) => {
  closeConfirm.value.open(INSPECTION_MESSAGES.LOAD_TYPE_DELETE_CONFIRM, BUTTONS.YES).then((response) => {
    if (response) {
      const index = loadRatingDetails.value?.findIndex((a) => a.RATING_KEY === item.RATING_KEY);
      if (index > -1) {
        changesDetected.value = true;
        loadRatingDetails.value.splice(index, 1);
        getLoadRatingDetails();
      }
    }
  });
};

const addRating = () => {
  previousSortBy.value = sortBy.value.map((x) => x);
  let newRating = clone(RATING_LOAD);
  newRating.BRKEY = brkey.value;
  newRating.RATING_DATE = getISOFormattedDateNoTime(calculationDate.value);
  newRating.RATING_KEY = loadRatingStore.getNewRatingKey(localLoadRatingDetails.value);
  newRating.isAdd = true;
  newRating.readOnly = false;
  localLoadRatingDetails.value?.unshift(newRating);
  expandedRows.value.push(newRating);
  snackBarId.value = snackbarStore.showMessage({
    displayText: INSPECTION_MESSAGES.RATINGS_DATATABLE,
  });
  addingOrEditingLoadRatingDetails.value = true;
  nextTick(() => loadRatingsDetailsForm.value?.validate());
};

const closeRating = () => {
  if (changesDetectedRating.value) {
    //show confirmation dialog on closing
    closeConfirm.value
      .open(INSPECTION_MESSAGES.DETECT_DATATABLE_CHANGE_CONFIRMATION_MESSAGE, BUTTONS.YES)
      .then((response) => {
        if (!response) {
          changesDetectedRating.value = false;
          getLoadRatingDetails();
          expandedRows.value = [];
          addingOrEditingLoadRatingDetails.value = false;
          duplicateLoadTypeValidationSnackbar.value = false;
          validationSnackbar.value = false;
          snackbarStore.removeMessage(snackBarId.value);
          snackBarId.value = snackbarStore.showMessage({
            displayText: COMMON_MESSAGE_CONSTANTS.CHANGES_DISCARDED,
            timeout: 10000,
            messageType: SNACKBAR_MESSAGE_TYPES.SUCCESS,
          });
          sortBy.value = previousSortBy.value?.map((x) => x);
        }
      });
  } else {
    getLoadRatingDetails();
    expandedRows.value = [];
    addingOrEditingLoadRatingDetails.value = false;
    duplicateLoadTypeValidationSnackbar.value = false;
    validationSnackbar.value = false;
    snackbarStore.removeMessage(snackBarId.value);
    sortBy.value = previousSortBy.value?.map((x) => x);
  }
};

const calculationDates = computed({
  get() {
    let dates = [];
    for (let ratingDate of loadRatingStore.getCalculationDates()) {
      dates.push(getISOFormattedDateWithTime(ratingDate));
    }
    return dates;
  },
});

watch(
  () => duplicateLoadTypeValidationSnackbar.value,
  (newVal) => {
    if (newVal) {
      duplicateLoadTypeTextId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.LOAD_RATING_DUPLICATE_LOAD_TYPE,
        timeout: 10000,
        messageType: SNACKBAR_MESSAGE_TYPES.ERROR,
        callback: () => {
          duplicateLoadTypeValidationSnackbar.value = false;
        },
      });
    } else {
      snackbarStore.removeMessage(duplicateLoadTypeTextId.value);
    }
  },
);

watch(show, async (newValue) => {
  localShowValue.value = newValue;
  loadRatingDetails.value = clone(ratingSet.value);
  calculationDate.value = null;
  getLoadRatingDetails();
  nextTick(() => ratingsSetPopupForm.value?.validate());
});
watch(ratingSet, (newValue) => {
  loadRatingDetails.value = clone(newValue);
  localLoadRatingDetails.value = clone(newValue);
});
</script>
